<mat-card>
    <mat-card-title>
        Sem horário disponível para a especialidade e convênio,
        deseja se registrar na lista de espera?
    </mat-card-title>
    <mat-dialog-actions>
      <button mat-button  mat-dialog-close>Cancelar</button>
      <button mat-raised-button  [mat-dialog-close]="true" color="accent">Sim</button>
    </mat-dialog-actions>
  </mat-card>